import React from "react";
import { Box, Typography, TextField } from "@mui/material";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

const TimeSelector = ({ logTime, onChangeTime }) => (
  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "16px" }}>
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <AccessTimeIcon sx={{ marginRight: "8px", color: "#4CAF50" }} />
      <Typography variant="body1">Start Time</Typography>
    </Box>
    <TimePicker
      value={logTime}
      onChange={onChangeTime}
      renderInput={(params) => <TextField {...params} sx={{ width: "100px", textAlign: "center" }} />}
    />
  </Box>
);

export default TimeSelector;